// Mock data for articles to simulate API responses
// New images for specific articles
import babySleepImg from "@images/baby-sleep.jpg";
import childDietImg from "@images/child-diet.jpg";
import childrenFirstAidImg from "@images/children-first-aid.jpg";
import pregnancyDietImg from "@images/pregnancy-diet.jpg";
import psychoSomaticDevelopmentImg from "@images/psycho-somatic-development.jpg";
import safeHomeChildrenImg from "@images/safe-home-children.jpg";
import vaccineImg from "@images/vaccacine.jpg";
import youthsPhysicalActivityImg from "@images/youths-psychical-activity.jpg";

// Mock image object structure matching the original API
const createMockImageSet = (url) => ({
    formats: {
        thumbnail: { url },
        small: { url },
        medium: { url },
        large: { url },
    },
    url,
});

export const mockArticles = [
    {
        id: 1,
        Title: "Zdrowe odżywianie dzieci - podstawy",
        Lead: "Poznaj najważniejsze zasady zdrowego żywienia najmłodszych. Dowiedz się, jak układać zbilansowane posiłki i jakich składników nie może zabraknąć w diecie dziecka.",
        slug: "zdrowe-odzywianie-dzieci-podstawy",
        Image: createMockImageSet(childDietImg),
        Content: `# Zdrowe odżywianie dzieci - podstawy

Zdrowe odżywianie jest fundamentem prawidłowego rozwoju dziecka. W pierwszych latach życia kształtują się nawyki żywieniowe, które mogą towarzyszyć człowiekowi przez całe życie.

## Najważniejsze zasady

### 1. Regularność posiłków
Dzieci powinny jeść 4-5 posiłków dziennie w regularnych odstępach czasu. Pomaga to w utrzymaniu stabilnego poziomu cukru we krwi i zapewnia stały dopływ energii.

### 2. Różnorodność
Dieta dziecka powinna być bogata w różnorodne produkty z wszystkich grup żywieniowych:
- Warzywa i owoce
- Produkty zbożowe
- Nabiał
- Mięso, ryby, jaja
- Tłuszcze roślinne

### 3. Odpowiednie proporcje
Każdy posiłek powinien zawierać:
- 50% warzyw i owoców
- 25% produktów zbożowych
- 25% białka

## Produkty, których należy unikać

W diecie dziecka należy ograniczyć:
- Słodycze i napoje słodzone
- Fast food
- Produkty wysoko przetworzone
- Nadmiar soli

## Podsumowanie

Pamiętaj, że ty jako rodzic jesteś najlepszym wzorem dla swojego dziecka. Pokazuj właściwe nawyki żywieniowe własnym przykładem.`,
        authors: [{ name: "Dr", surname: "Anna Kowalska" }],
        position: 1,
    },
    {
        id: 2,
        Title: "Rozwój psychomotoryczny niemowląt",
        Lead: "Pierwszy rok życia dziecka to okres intensywnego rozwoju. Sprawdź, jakie umiejętności powinno rozwijać twoje dziecko w poszczególnych miesiącach życia.",
        slug: "rozwoj-psychomotoryczny-niemowlat",
        Image: createMockImageSet(psychoSomaticDevelopmentImg),
        Content: `# Rozwój psychomotoryczny niemowląt

Pierwszy rok życia dziecka to czas niezwykłych przemian. Każdy miesiąc przynosi nowe umiejętności i osiągnięcia rozwojowe.

## Pierwsze miesiące (0-3 miesiące)

W tym okresie dziecko:
- Uczą się skupiać wzrok na przedmiotach
- Zaczynają uśmiechać się świadomie
- Podnoszą główkę leżąc na brzuszku
- Reagują na głosy rodziców

## Okres 3-6 miesięcy

Dziecko w tym wieku:
- Siada z podparciem
- Chwyta przedmioty całą dłonią
- Śmieje się głośno
- Przewraca się z brzuszka na plecy

## Druga połowa roku (6-12 miesięcy)

To czas, kiedy dziecko:
- Siedzi samodzielnie
- Czołga się lub raczkuje
- Staje przy meblach
- Mówi pierwsze słowa
- Chodzi z podparciem

## Jak wspierać rozwój?

- Zapewnij dziecku bezpieczną przestrzeń do eksploracji
- Czytaj dziecku książeczki
- Śpiewaj i rozmawiaj z maluchem
- Baw się w gry rozwojowe
- Regularnie odwiedzaj pediatrę

## Kiedy skonsultować się z lekarzem?

Skontaktuj się z pediatrą, jeśli:
- Dziecko nie osiąga kamieni milowych rozwoju
- Zauważasz regres w umiejętnościach
- Masz obawy co do rozwoju dziecka

Pamiętaj, że każde dziecko rozwija się we własnym tempie!`,
        authors: [{ name: "Mgr", surname: "Katarzyna Nowak" }],
        position: 2,
    },
    {
        id: 3,
        Title: "Dieta w ciąży - co jeść, czego unikać",
        Lead: "Ciąża to szczególny okres w życiu kobiety, kiedy to, co je przyszła mama, wpływa bezpośrednio na rozwój dziecka. Poznaj zasady zdrowego żywienia w ciąży.",
        slug: "dieta-w-ciazy-co-jesc-czego-unikac",
        Image: createMockImageSet(pregnancyDietImg),
        Content: `# Dieta w ciąży - co jeść, czego unikać

Prawidłowe odżywianie w ciąży ma kluczowe znaczenie dla zdrowia zarówno mamy, jak i rozwijającego się dziecka.

## Co jeść w ciąży?

### Białko
- Chude mięso
- Ryby (unikaj tych z wysoką zawartością rtęci)
- Jaja
- Rośliny strączkowe
- Orzechy i nasiona

### Węglowodany złożone
- Produkty pełnoziarniste
- Warzywa
- Owoce

### Tłuszcze zdrowe
- Awokado
- Oliwa z oliwek
- Orzechy
- Ryby tłuste

### Wapń
- Nabiał
- Zielone warzywa liściaste
- Migdały
- Sardynki

## Czego unikać?

### Alkohol
Całkowicie wyeliminuj alkohol z diety.

### Kofeina
Ogranicz do maksymalnie 200mg dziennie.

### Ryby z wysoką zawartością rtęci
- Rekin
- Miecznik
- Tuńczyk (ogranicz)

### Surowe produkty
- Surowe mięso i ryby
- Niepasteryzowane nabiał
- Surowe jaja

## Suplementacja

Skonsultuj z lekarzem suplementację:
- Kwasu foliowego
- Żelaza
- Witaminy D
- Omega-3

## Podsumowanie

Pamiętaj, że nie musisz "jeść za dwoje". Ważniejsza jest jakość niż ilość spożywanych posiłków.`,
        authors: [{ name: "Lek. med.", surname: "Magdalena Wiśniewska" }],
        position: 3,
    },
    {
        id: 4,
        Title: "Bezpieczny dom dla dziecka",
        Lead: "Dom to miejsce, gdzie dziecko spędza większość czasu. Dowiedz się, jak zabezpieczyć swoje mieszkanie, aby było bezpieczne dla najmłodszych domowników.",
        slug: "bezpieczny-dom-dla-dziecka",
        Image: createMockImageSet(safeHomeChildrenImg),
        Content: `# Bezpieczny dom dla dziecka

Bezpieczeństwo dziecka w domu to priorytet każdego rodzica. Oto najważniejsze zasady, które pomogą ci zabezpieczyć mieszkanie.

## Kuchnia

### Podstawowe zabezpieczenia:
- Blokady szafek i szuflad
- Zabezpieczenia piekarnika i kuchenki
- Osłony na ostre rogi
- Zamki na lodówkę

### Produkty chemiczne:
- Przechowuj środki czyszczące w zamkniętych szafkach
- Używaj zabezpieczeń na szafki
- Trzymaj noże w blokowanych szufladach

## Łazienka

### Woda:
- Zawsze sprawdzaj temperaturę wody
- Nie zostawiaj dziecka samego w wannie
- Używaj mat antypoślizgowych

### Leki i kosmetyki:
- Przechowuj w zamkniętych szafkach
- Używaj opakowań z zabezpieczeniami
- Regularnie sprawdzaj daty ważności

## Salon i sypialnia

### Meble:
- Przymocuj wysokie meble do ściany
- Zabezpiecz ostre rogi
- Schowaj małe przedmioty

### Elektryka:
- Używaj osłon na gniazdka
- Schowaj przewody
- Zabezpiecz sprzęt elektroniczny

## Schody

- Bramki bezpieczeństwa u góry i u dołu
- Poręcze w odpowiedniej wysokości
- Antypoślizgowe nakładki na stopnie

## Okna i balkony

- Blokady okien
- Siatki ochronne
- Zabezpieczenia balkonów

## Ogród

- Ogrodzenie basenu
- Usunięcie trujących roślin
- Zabezpieczenie narzędzi ogrodowych

Pamiętaj: najlepszym zabezpieczeniem jest ciągły nadzór dorosłego!`,
        authors: [{ name: "Insp.", surname: "Tomasz Kowalczyk" }],
        position: 4,
    },
    {
        id: 5,
        Title: "Pierwsza pomoc dla dzieci - podstawy",
        Lead: "Każdy rodzic powinien znać podstawy pierwszej pomocy. Dowiedz się, jak postępować w najczęstszych sytuacjach zagrożenia zdrowia dziecka.",
        slug: "pierwsza-pomoc-dla-dzieci-podstawy",
        Image: createMockImageSet(childrenFirstAidImg),
        Content: `# Pierwsza pomoc dzieciom

Znajomość podstaw pierwszej pomocy to umiejętność, którą powinien posiadać każdy rodzic i opiekun dziecka.

## Podstawowe zasady

### Zachowaj spokój
- Twoja panika może pogorszyć sytuację
- Dziecko wyczuwa twój strach
- Spokojne działanie jest skuteczniejsze

### Oceń sytuację
- Sprawdź, czy miejsce jest bezpieczne
- Określ stan dziecka
- Zdecyduj, czy potrzebna jest pomoc medyczna

## Najczęstsze sytuacje

### Krwawienie
1. Przyłóż czysty materiał na ranę
2. Uciskaj miejsce krwawienia
3. Unieś kończynę powyżej poziomu serca
4. Jeśli krwawienie nie ustępuje - wzywaj pomoc

### Oparzenia
1. Chłódź zimną wodą przez 10-20 minut
2. Nie używaj lodu
3. Nie smaruj masłem ani kremami
4. Okryj czystym materiałem

### Zadławienie
**Niemowlęta (do 1 roku):**
1. Połóż dziecko na przedramieniu twarzą w dół
2. Wykonaj 5 uderzeń między łopatkami
3. Obróć dziecko i wykonaj 5 uciśnięć klatki piersiowej

**Dzieci powyżej roku:**
1. Stań za dzieckiem
2. Połóż ręce pod żebrami
3. Wykonaj szybkie uciśnięcia w kierunku w górę i do wewnątrz

### Utrata przytomności
1. Sprawdź oddech
2. Ułóż dziecko w pozycji bezpiecznej
3. Wzywaj pomoc medyczną
4. Monitoruj stan dziecka

## Kiedy wzywać pomoc?

Natychmiast wzywaj pogotowie (112) gdy:
- Dziecko nie oddycha
- Silne krwawienie
- Podejrzenie złamania
- Utrata przytomności
- Zatrucie
- Poważne oparzenia

## Apteczka pierwszej pomocy

Powinna zawierać:
- Plastry różnych rozmiarów
- Bandaże
- Gazę sterylną
- Termometr
- Nożyczki
- Rękawiczki jednorazowe
- Środek dezynfekujący

Pamiętaj: pierwsza pomoc to działania tymczasowe do czasu przybycia pomocy medycznej!`,
        authors: [{ name: "Ratownik med.", surname: "Paweł Zieliński" }],
        position: 5,
    },
    {
        id: 6,
        Title: "Sen dziecka - jak zapewnić zdrowy odpoczynek",
        Lead: "Zdrowy sen to podstawa prawidłowego rozwoju dziecka. Poznaj zasady higieny snu i sposoby na radzenie sobie z problemami ze snem u najmłodszych.",
        slug: "sen-dziecka-zdrowy-odpoczynek",
        Image: createMockImageSet(babySleepImg),
        Content: `# Sen dziecka - jak zapewnić spokojny odpoczynek

Sen odgrywa kluczową rolę w rozwoju dziecka. To podczas snu organizm regeneruje się, a mózg przetwarza informacje z dnia.

## Ile snu potrzebuje dziecko?

### Niemowlęta (0-3 miesiące)
- 14-17 godzin na dobę
- Sen jest nieregularny
- Budzenie się co 2-3 godziny to norma

### Niemowlęta (4-11 miesięcy)
- 12-15 godzin na dobę
- Zaczynają spać dłużej w nocy
- 2-3 drzemki w ciągu dnia

### Małe dzieci (1-2 lata)
- 11-14 godzin na dobę
- Jedna drzemka w ciągu dnia
- Regularne pory snu

### Dzieci przedszkolne (3-5 lat)
- 10-13 godzin na dobę
- Niektóre dzieci nadal potrzebują drzemki
- Ważna regularna pora kładzenia

## Jak stworzyć dobrą higienę snu?

### Stała rutyna
- Kładź dziecko spać o tej samej porze
- Stwórz rytuał przed snem
- Bądź konsekwentny każdego dnia

### Odpowiednie środowisko
- Temperatura pokoju: 18-20°C
- Ciemność lub przyćmione światło
- Cisza lub delikatne odgłosy
- Wygodne łóżko i pościel

### Rytuał przed snem
- Kąpiel
- Czytanie bajki
- Spokojna muzyka
- Przytulanie

## Częste problemy ze snem

### Trudności z zasypianiem
- Sprawdź, czy dziecko nie jest przestymulowane
- Unikaj ekranów przed snem
- Zapewnij spokojną atmosferę

### Częste budzenie się w nocy
- Sprawdź, czy dziecko nie jest głodne lub mokre
- Unikaj zbyt długich drzemek w ciągu dnia
- Bądź cierpliwy - to może być faza rozwojowa

### Koszmary nocne
- Uspokój dziecko
- Zostań z nim do zaśnięcia
- Unikaj strasznych bajek przed snem

## Kiedy skonsultować się z lekarzem?

- Dziecko ma poważne problemy z zasypianiem
- Częste budzenie się w nocy przez długi czas
- Chrapanie lub problemy z oddychaniem
- Nadmierna senność w ciągu dnia

Pamiętaj: każde dziecko ma indywidualne potrzeby senne!`,
        authors: [{ name: "Dr", surname: "Maria Lewandowska" }],
        position: 6,
    },
    {
        id: 7,
        Title: "Aktywność fizyczna dzieci w różnym wieku",
        Lead: "Ruch to zdrowie! Dowiedz się, jak zachęcić dziecko do aktywności fizycznej i jakie formy ruchu są najlepsze w poszczególnych etapach rozwoju.",
        slug: "aktywnosc-fizyczna-dzieci-rozny-wiek",
        Image: createMockImageSet(youthsPhysicalActivityImg),
        Content: `# Aktywność fizyczna dzieci w różnym wieku

Regularna aktywność fizyczna jest kluczowa dla prawidłowego rozwoju dziecka. Pomaga w budowaniu silnych kości i mięśni, rozwija koordynację i równowagę.

## Korzyści z aktywności fizycznej

### Korzyści fizyczne:
- Wzmocnienie mięśni i kości
- Rozwój koordynacji ruchowej
- Poprawa kondycji sercowo-naczyniowej
- Utrzymanie zdrowej wagi ciała

### Korzyści psychiczne:
- Poprawa nastroju
- Redukcja stresu
- Lepszy sen
- Wzrost pewności siebie

### Korzyści społeczne:
- Nauka pracy w zespole
- Rozwój umiejętności społecznych
- Budowanie przyjaźni
- Nauka fair play

## Aktywność według wieku

### Niemowlęta (0-12 miesięcy)
- Czas na brzuszku
- Swobodne poruszanie się
- Zabawa z rodzicami
- Odkrywanie otoczenia

### Małe dzieci (1-3 lata)
- Minimum 180 minut aktywności dziennie
- Chodzenie, bieganie, wspinaczka
- Zabawa na placu zabaw
- Taniec do muzyki

### Dzieci przedszkolne (3-5 lat)
- Minimum 180 minut aktywności dziennie
- W tym 60 minut intensywnej aktywności
- Jazda na rowerku
- Gry z piłką
- Pływanie

### Dzieci szkolne (6+ lat)
- Minimum 60 minut umiarkowanej do intensywnej aktywności
- Sport zespołowy
- Jazda na rowerze
- Pływanie
- Biegi

## Pomysły na aktywność

### W domu:
- Taniec do muzyki
- Joga dla dzieci
- Przeszkody z poduszek
- Zabawa w berka

### Na dworze:
- Spacery i wędrówki
- Jazda na rowerze
- Gry z piłką
- Zabawa na placu zabaw

### W wodzie:
- Pływanie
- Zabawy w basenie
- Gry wodne
- Nauka pływania

## Jak zachęcić dziecko?

- Bądź przykładem
- Znajdź aktywności, które lubisz
- Nie zmuszaj, ale zachęcaj
- Świętuj małe sukcesy
- Rób to razem z dzieckiem

## Bezpieczeństwo

- Zawsze nadzoruj małe dzieci
- Używaj odpowiedniego sprzętu ochronnego
- Sprawdzaj miejsce zabawy
- Pamiętaj o nawodnieniu
- Dostosuj aktywność do pogody

Pamiętaj: najważniejsze, żeby dziecko się bawiło!`,
        authors: [{ name: "Mgr", surname: "Piotr Adamski" }],
        position: 7,
    },
    {
        id: 8,
        Title: "Szczepienia obowiązkowe - kalendarz i znaczenie",
        Lead: "Szczepienia to najskuteczniejsza metoda ochrony przed groźnymi chorobami zakaźnymi. Poznaj kalendarz szczepień i dowiedz się, dlaczego są tak ważne.",
        slug: "szczepienia-obowiazkowe-kalendarz-znaczenie",
        Image: createMockImageSet(vaccineImg),
        Content: `# Szczepienia - ochrona przed chorobami

Szczepienia to jedna z najważniejszych zdobyczy medycyny. Dzięki nim udało się wyeliminować lub znacznie ograniczyć występowanie wielu groźnych chorób.

## Jak działają szczepienia?

Szczepionki zawierają:
- Osłabione lub martwe drobnoustroje
- Fragmenty drobnoustrojów
- Toksyny w osłabionej formie

Po podaniu szczepionki organizm:
1. Rozpoznaje obce substancje
2. Wytwarza przeciwciała
3. Zapamiętuje jak walczyć z chorobą
4. Jest gotowy na prawdziwą infekcję

## Kalendarz szczepień obowiązkowych

### Niemowlęta:
- **1. doba życia**: WZW B
- **2. miesiąc**: WZW B, DTaP, IPV, Hib, PCV
- **3-4. miesiąc**: DTaP, IPV, Hib, PCV
- **5-6. miesiąc**: DTaP, IPV, Hib, PCV, WZW B

### Dzieci starsze:
- **13-15. miesiąc**: MMR, PCV
- **16-18. miesiąc**: DTaP, IPV, Hib
- **6 lat**: DTaP, IPV, MMR
- **14 lat**: dT
- **19 lat**: dT

## Szczepienia zalecane

### HPV (wirus brodawczaka ludzkiego)
- Dla dziewcząt i chłopców
- Najlepiej przed rozpoczęciem życia płciowego
- Ochrona przed rakiem szyjki macicy

### Grypa
- Szczególnie dla dzieci z grup ryzyka
- Corocznie jesienią
- Ochrona przed powikłaniami grypy

### Rotawirusy
- Dla niemowląt
- Ochrona przed biegunkami
- Podawane doustnie

## Przeciwwskazania

### Bezwzględne:
- Ciężka reakcja alergiczna na poprzednią dawkę
- Ciężki niedobór odporności
- Ciężka choroba z gorączką

### Względne:
- Lekka infekcja bez gorączki
- Przyjmowanie antybiotyków
- Wcześniactwo (ale nie przeciwwskazanie!)

## Działania niepożądane

### Częste i łagodne:
- Zaczerwienienie w miejscu wkłucia
- Lekka gorączka
- Rozdrażnienie
- Senność

### Rzadkie i poważne:
- Silna reakcja alergiczna
- Wysoka gorączka
- Drgawki gorączkowe

## Mity o szczepieniach

### Mit: Szczepienia powodują autyzm
**Fakt**: Liczne badania wykluczyły związek między szczepieniami a autyzmem.

### Mit: Naturalna odporność jest lepsza
**Fakt**: Naturalna infekcja niesie ryzyko poważnych powikłań.

### Mit: Szczepionki zawierają szkodliwe substancje
**Fakt**: Wszystkie składniki są bezpieczne w zastosowanych dawkach.

## Przygotowanie do szczepienia

- Dziecko powinno być zdrowe
- Poinformuj lekarza o wszystkich lekach
- Zabierz książeczkę zdrowia
- Zostań 15 minut po szczepieniu

Pamiętaj: szczepienia chronią nie tylko twoje dziecko, ale całą społeczność!`,
        authors: [{ name: "Dr hab.", surname: "Anna Szczepańska" }],
        position: 8,
    },
];

// Helper function to get articles by URL pattern (simulating API endpoints)
export const getArticlesByEndpoint = (endpoint) => {
    // Simulate different API endpoints
    if (endpoint.includes("_sort=position:DESC")) {
        return mockArticles.sort((a, b) => b.position - a.position);
    }

    return mockArticles;
};

// Helper function to get single article by slug
export const getArticleBySlug = (slug) => {
    return mockArticles.find((article) => article.slug === slug);
};
